var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
        [
          _c("span", [_vm._v(" Viendo documentos que ingresaron ")]),
          _vm._v(" "),
          _vm.periodoSeleccionado.valor !== "personalizado"
            ? _c("span", [
                _vm._v(" " + _vm._s(_vm.periodoSeleccionado.nombre) + " ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.periodoSeleccionado.valor === "personalizado"
            ? _c(
                "span",
                [
                  _vm._v(" entre el "),
                  _c("datetime", {
                    attrs: {
                      "input-class": "fecha",
                      phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                      "value-zone": "local",
                      format: "yyyy-MM-dd",
                      "data-cy": "start-time"
                    },
                    model: {
                      value: _vm.periodoDesde,
                      callback: function($$v) {
                        _vm.periodoDesde = $$v
                      },
                      expression: "periodoDesde"
                    }
                  }),
                  _vm._v(" y el "),
                  _c("datetime", {
                    attrs: {
                      "input-class": "fecha",
                      phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                      "value-zone": "local",
                      format: "yyyy-MM-dd",
                      "data-cy": "end-time"
                    },
                    model: {
                      value: _vm.periodoHasta,
                      callback: function($$v) {
                        _vm.periodoHasta = $$v
                      },
                      expression: "periodoHasta"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "vs-dropdown",
            {
              staticStyle: { "margin-left": "15px" },
              attrs: { "vs-trigger-click": "" }
            },
            [
              _c(
                "a",
                { staticClass: "a-icon", attrs: { href: "#" } },
                [
                  _vm._v(" Cambiar "),
                  _c("vs-icon", { attrs: { icon: "expand_more" } })
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                _vm._l(_vm.periodos, function(periodo) {
                  return _c(
                    "vs-dropdown-item",
                    {
                      key: periodo.valor,
                      staticStyle: { width: "200px" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.seleccionarPeriodo(periodo)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(periodo.nombre) + " ")]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("filtros", {
        attrs: {
          dntType: "approvalFiles",
          users: _vm.usersCompany,
          groups: _vm.groupsCompany,
          "configuracion-vista": _vm.configuracion,
          periodos: _vm.periodos
        },
        on: { "filtros-aplicados": _vm.changeFilters }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }